import { Link } from "react-router-dom"


const TitleCell = ({ post }) => (
    <Link to={`/blog/posts/${post.id}`}>
        <span className="fw-bold text-dark text-hover-primary">{post.title}</span>
    </Link>
)

export default TitleCell